<script setup lang="ts">
import { useProductParams } from '@/composables/useProductParams';
const { id } = useProductParams();
const { data: category, fetchCategory } = useCategory();
const { data: searchData } = useSearch();
const { data: bootstrap } = useBootstrap();
const route = useRoute();

await fetchCategory();

useSeoMeta({
  title: category.value?.meta_title || category.value?.name,
  description: category.value?.meta_description || category.value?.description,
  ogTitle: category.value?.meta_title || category.value?.name,
  ogDescription: category.value?.meta_description || category.value?.description,
  ogImage: category.value?.images?.medium?.url,
});

// Build pagination and canonical links
const headLinks = computed(() => {
  const links = [];
  const currentPage = searchData.value?.pagination?.current_page || 1;
  const totalPages = searchData.value?.pagination?.pages_count || 1;
  const baseUrl = category.value?.alternative_urls[bootstrap.value?.languages.current_language.country_code ?? ''] || route.path;

  // Add canonical link (points to the base category page)
  links.push({
    rel: 'canonical',
    href: baseUrl,
  });

  // Add alternative language links
  if (category.value?.alternative_urls) {
    links.push(
      ...Object.keys(category.value.alternative_urls).map((lang) => ({
        rel: 'alternate',
        hreflang: lang,
        href: category.value?.alternative_urls[lang],
      })),
      {
        rel: 'alternate',
        hreflang: 'x-default',
        href: category.value.alternative_urls['en-us'] ?? '',
      }
    );
  }

  // Add prev link if not on first page
  if (currentPage > 1) {
    const prevPage = currentPage - 1;
    const prevUrl = prevPage === 1 ? baseUrl : `${baseUrl}?page=${prevPage}`;
    links.push({
      rel: 'prev',
      href: prevUrl,
    });
  }

  // Add next link if not on last page
  if (currentPage < totalPages) {
    const nextPage = currentPage + 1;
    links.push({
      rel: 'next',
      href: `${baseUrl}?page=${nextPage}`,
    });
  }

  return links;
});

useHead(() => ({
  link: headLinks.value,
}));
</script>

<template>
  <VContainer>
    <VProductListing
      :categoryId="id"
      :title="category?.name"
      :short_description="category?.description"
      :category="category"
    />
  </VContainer>
</template>
